import React from "react";

/**
 * Skeleton loading components — brand-themed, mobile-first.
 *
 * Usage: <SkeletonCard count={6} />   → 6 card placeholders
 *        <SkeletonTable rows={5} cols={4} />
 *        <SkeletonProfile />
 *        <SkeletonText lines={4} />
 *        <SkeletonDetailPage />
 */

/* Card skeleton — used for car listing grids */
export const SkeletonCard = ({ count = 6 }) => (
  <div className="row g-3">
    {Array.from({ length: count }).map((_, i) => (
      <div className="col-6 col-md-4 col-lg-3" key={i}>
        <div className="sk-card">
          <div className="sk-img sk-pulse"></div>
          <div className="sk-body">
            <div className="sk-line sk-line-title sk-pulse"></div>
            <div className="sk-line sk-line-short sk-pulse"></div>
            <div className="sk-row">
              <div className="sk-tag sk-pulse"></div>
              <div className="sk-tag sk-pulse"></div>
            </div>
            <div className="sk-line sk-line-price sk-pulse"></div>
          </div>
        </div>
      </div>
    ))}
  </div>
);

/* Table skeleton — used for data tables */
export const SkeletonTable = ({ rows = 5, cols = 4 }) => (
  <div className="sk-table">
    <div className="sk-table-header">
      {Array.from({ length: cols }).map((_, i) => (
        <div className="sk-table-cell sk-pulse" key={i}></div>
      ))}
    </div>
    {Array.from({ length: rows }).map((_, r) => (
      <div className="sk-table-row" key={r}>
        {Array.from({ length: cols }).map((_, c) => (
          <div className="sk-table-cell sk-pulse" key={c}></div>
        ))}
      </div>
    ))}
  </div>
);

/* Profile page skeleton */
export const SkeletonProfile = () => (
  <div className="sk-profile">
    <div className="sk-avatar sk-pulse"></div>
    <div className="sk-line sk-line-title sk-pulse" style={{ width: "40%", margin: "12px auto 6px" }}></div>
    <div className="sk-line sk-line-short sk-pulse" style={{ width: "25%", margin: "0 auto 20px" }}></div>
    <div className="sk-card" style={{ padding: "16px" }}>
      {Array.from({ length: 5 }).map((_, i) => (
        <div className="sk-info-row" key={i}>
          <div className="sk-line sk-pulse" style={{ width: "30%" }}></div>
          <div className="sk-line sk-pulse" style={{ width: "50%" }}></div>
        </div>
      ))}
    </div>
  </div>
);

/* Text block skeleton */
export const SkeletonText = ({ lines = 4 }) => (
  <div className="sk-text-block">
    {Array.from({ length: lines }).map((_, i) => (
      <div className="sk-line sk-pulse" key={i}
        style={{ width: i === lines - 1 ? "60%" : `${85 + Math.random() * 15}%` }}></div>
    ))}
  </div>
);

/* Dashboard stat cards skeleton */
export const SkeletonDashboard = ({ cards = 4 }) => (
  <div className="row g-3 mb-4">
    {Array.from({ length: cards }).map((_, i) => (
      <div className="col-6 col-lg-3" key={i}>
        <div className="sk-stat-card sk-pulse">
          <div className="sk-line" style={{ width: "50%", height: 12, marginBottom: 10 }}></div>
          <div className="sk-line" style={{ width: "35%", height: 22 }}></div>
        </div>
      </div>
    ))}
  </div>
);

/* Detail page skeleton (e.g., car detail) */
export const SkeletonDetailPage = () => (
  <div className="sk-detail-page">
    <div className="row g-3">
      <div className="col-md-7">
        <div className="sk-img sk-pulse" style={{ height: 320, borderRadius: 14 }}></div>
        <div className="d-flex gap-2 mt-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <div className="sk-img sk-pulse" key={i}
              style={{ width: "25%", height: 60, borderRadius: 8 }}></div>
          ))}
        </div>
      </div>
      <div className="col-md-5">
        <div className="sk-line sk-line-title sk-pulse" style={{ width: "80%" }}></div>
        <div className="sk-line sk-pulse" style={{ width: "50%", height: 24, margin: "8px 0 16px" }}></div>
        <div className="sk-card" style={{ padding: 16 }}>
          {Array.from({ length: 6 }).map((_, i) => (
            <div className="sk-info-row" key={i}>
              <div className="sk-line sk-pulse" style={{ width: "35%" }}></div>
              <div className="sk-line sk-pulse" style={{ width: "45%" }}></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);
